import React from "react";
import WritingPad from "../UiElements/WritingPad";
import { localStore } from "../../helpers/localStorage";
import firebase from "../../helpers/firebase";
import { updateTime, deleteCollection } from "../../helpers/firebaseCRUD";
import { useHistory } from "react-router-dom";

function WriteProblemStatement() {
  const history = useHistory();
  const db = firebase.firestore();
  let sessionId = localStore.getSession();

  if (sessionId) {
    updateTime();
  }

  const saveProblemStatement = async (data) => {
    try {
      if (data && data.src && data["mathml"]) {
        //Store problem statement
        await db
          .collection("sessions")
          .doc(sessionId)
          .set({ problemStatement: data }, { merge: true });
        //delete old answers
        deleteCollection(`sessions/${sessionId}/answers`);
        localStore.setProblemStatement(data);
        history.push("/instructor/preview_statement");
      } else {
        console.log("Something went wrong while trying to save exercise");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };
  return (
    <>
      <WritingPad
        fullScreen={false}
        submitBtnText="Next"
        onSubmit={saveProblemStatement}
      />
    </>
  );
}

export default WriteProblemStatement;
